import { createTheme } from "@mui/material/styles";
const theme = createTheme({
    palette: {
      secondary: {
        main: "#D9863D",
      },
    },
  });
export default theme;